const GAS_MIXTURE = ["AIR", "MIX"];

export default GAS_MIXTURE;
